import { MatIconModule } from '@angular/material/icon';
import { ButtonModule } from './../button/button.module';
import { SwiperDirective } from './swiper.directive';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselComponent } from './carousel.component';
import { CarouselSlideDirective } from './carousel-slide.component';
// import SwiperCore, {
//   A11y,
//   EffectCreative,
//   Navigation,
//   Pagination,
//   Scrollbar,
// } from 'swiper';
import { register } from 'swiper/element/bundle';

register();
// SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, EffectCreative]);

@NgModule({
  declarations: [SwiperDirective, CarouselComponent, CarouselSlideDirective],
  imports: [CommonModule, ButtonModule, MatIconModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [CarouselComponent, CarouselSlideDirective, SwiperDirective],
})
export class CarouselModule {}
